/* eslint-disable */
import _ from "lodash/fp";
import { useEffect, useRef } from "react";
import { useForm } from "react-hook-form";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { SET_ALL_TALUKA } from "../../../common/constants/ActionTypes";
import commonLabels from "../../../common/labels/common_en.json";
import {
  addTalukaData,
  editTaluka,
  getAllTalukaDistricts,
  resetTaluka,
  resetTalukaList,
} from "../actions/masterManagementAction";
import masterLabels from "../labels/master_en.json";
import TehsilList from "./TehsilList";
import Select from "react-select";

const TehsilForm = ({
  addTaluka,
  setAddTaluka,
  isActive,
  setIsActive,
  setTalukaState,
  setTalukaDistrict,
  talukaCode,
  talukaName,
  talukaState,
  talukaDistrict,
  setTalukaCode,
  setTalukaName,
}) => {
  const dispatch = useDispatch();
  const { register, handleSubmit, errors } = useForm({
    mode: "onChange",
  });
  const inputRef = useRef();

  const onSubmit = (data, addTaluka, setAddTaluka, isActive) => {
    let requestBody = {
      talukaDto: {
        code: data.talukaState,
        districtcode: talukaDistrict,
        name: data.talukaName,
        // "translations": null,
        isActive: isActive,
        isDeleted: "false",
      },
    };

    dispatch(resetTalukaList());
    if (addTaluka.Mode == "Add") {
      dispatch(
        addTalukaData(
          requestBody,
          setAddTaluka,
          setTalukaState,
          setTalukaDistrict,
          setTalukaName,
          setTalukaCode
        )
      );
    } else if (addTaluka.Mode == "Edit") {
      requestBody.talukaDto.code = addTaluka.talukaCode;
      requestBody.talukaDto.districtcode = addTaluka.talukaDistrict;
      dispatch(
        editTaluka(
          requestBody,
          setAddTaluka,
          setTalukaState,
          setTalukaDistrict,
          setTalukaName,
          setTalukaCode
        )
      );
    }
  };

  useEffect(() => {
    if (addTaluka && addTaluka.Mode == "Add") {
      dispatch(resetTalukaList());
      setTalukaState(false);
      setTalukaName("");
      setTalukaCode("");
      setTalukaDistrict(false);
      setIsActive(false);
    }

    // addTaluka.Mode == "Edit" && addTaluka.talukaCode > 0 && dispatch(getTalukaData(addTaluka.talukaCode));
    addTaluka.Mode == "Edit" &&
      addTaluka.talukaCode > 0 &&
      dispatch(getAllTalukaDistricts(addTaluka.talukaState));
    addTaluka.Mode == "Edit" &&
      addTaluka.talukaCode > 0 &&
      setTalukaState(addTaluka.talukaState);
    addTaluka.Mode == "Edit" &&
      addTaluka.talukaCode > 0 &&
      setTalukaDistrict(addTaluka.talukaDistrict);
    dispatch({
      type: SET_ALL_TALUKA,
      payload: {},
    });
    // eslint-disable-next-line
  }, []);

  const onTalukaStateChange = (e) => {
    dispatch(resetTaluka());
    dispatch(resetTalukaList());
    let talukaSelectedState = e.target.value;
    setTalukaState(talukaSelectedState);
    dispatch(getAllTalukaDistricts(talukaSelectedState));
  };
  const onDistrictChange = (e) => {
    dispatch(resetTalukaList());
    let talukaSelectedDistrict = e.target.value;
    setTalukaDistrict(talukaSelectedDistrict);
  };

  const { talukaStatesList, talukaDistrictsList, talukaDetails } = useSelector(
    (state) => state.masterManagementReducer,
    shallowEqual
  );

  const onCancelButton = () => {
    setAddTaluka({ Mode: false });
    setTalukaState(false);
    setTalukaDistrict(false);
    setTalukaName("");
    setTalukaCode("");
    setIsActive(false);
    dispatch(resetTaluka());
    dispatch(resetTalukaList());
  };

  // Prepare the options
  const talukaStateOptions =
    talukaStatesList?.stateDtoList?.map((element) => ({
      value: element.code,
      label: element.name,
    })) || [];

  // Determine selected value for Edit mode or from state
  const selectedTalukaState =
    talukaStateOptions.find(
      (option) =>
        option.value ===
        (addTaluka?.Mode === "Edit" ? addTaluka?.talukastate : talukaState)
    ) || null;

  const talukaDistrictOptions =
    talukaDistrictsList?.districtList?.map((element) => ({
      value: element.code,
      label: element.name,
    })) || [];

  const selectedTalukaDistrict =
    talukaDistrictOptions.find(
      (option) =>
        option.value ===
        (addTaluka?.Mode === "Edit"
          ? addTaluka?.talukaDistrict
          : talukaDistrict)
    ) || null;

  return addTaluka.Mode == false ? (
    <div>
      <TehsilList setAddTaluka={setAddTaluka} />
    </div>
  ) : (
    <div>
      <form>
        <div className="border border-light text-center w-100 p-5">
          <div className="form-group">
            <div className="row">
              <div className="col-md-6">
                <h4>
                  <p className="float-left">
                    {addTaluka.Mode == "Add"
                      ? masterLabels.talukaForm.Add_Taluka
                      : masterLabels.talukaForm.Update_Taluka}
                  </p>
                </h4>
              </div>
            </div>
          </div>
          <br />
          <div className="form-group">
            <div className="row">
              <div className="col-md-2">
                <label className="float-left font-weight-bold">
                  {masterLabels.talukaForm.States}
                  <span className="redColor">*</span>
                </label>
                {/* <select
                  className="form-control mt-1"
                  name="talukaState"
                  value={talukaState}
                  onInput={onTalukaStateChange}
                  ref={register({ required: true })}
                  defaultValue={
                    addTaluka &&
                    addTaluka.Mode == "Edit" &&
                    addTaluka.talukastate
                  }
                  disabled={addTaluka && addTaluka.Mode == "Edit" && true}
                >
                  <option key={0} value="">
                    {commonLabels.COMBO_SELECT}
                  </option>
                  {talukaStatesList &&
                    talukaStatesList.stateDtoList &&
                    talukaStatesList.stateDtoList.length > 0 &&
                    talukaStatesList.stateDtoList.map((element, index) => (
                      <option key={index} value={element.code}>
                        {element.name}
                      </option>
                    ))}
                </select> */}
                <br />
                <Select
                  className="mt-1"
                  name="talukaState"
                  options={talukaStateOptions}
                  value={selectedTalukaState}
                  placeholder={commonLabels.COMBO_SELECT}
                  onChange={(selectedOption) => {
                    const value = selectedOption?.value || "";
                    onTalukaStateChange({
                      target: {
                        name: "talukaState",
                        value,
                      },
                    });
                  }}
                  isClearable
                  isDisabled={addTaluka?.Mode === "Edit"}
                  ref={inputRef}
                />

                {_.get("talukaState.type", errors) === "required" && (
                  <p className="errorText float-left">
                    {commonLabels.MANDATORY_FIELD_MESSAGE}
                  </p>
                )}
              </div>

              <div className="col-md-2">
                <label className="float-left font-weight-bold">
                  {masterLabels.talukaForm.Districts}
                  <span className="redColor">*</span>
                </label>
                {/* <select
                  className="form-control mt-1"
                  name="talukaDistrict"
                  value={talukaDistrict}
                  onInput={onDistrictChange}
                  ref={register({ required: true })}
                  defaultValue={
                    addTaluka &&
                    addTaluka.Mode == "Edit" &&
                    addTaluka.talukaDistrict
                  }
                  disabled={addTaluka && addTaluka.Mode == "Edit" && true}
                >
                  <option key={0} value="">
                    {commonLabels.COMBO_SELECT}
                  </option>
                  {talukaDistrictsList &&
                    talukaDistrictsList.districtList &&
                    talukaDistrictsList.districtList.length > 0 &&
                    talukaDistrictsList.districtList.map((element, index) => (
                      <option key={index} value={element.code}>
                        {element.name}
                      </option>
                    ))}
                </select> */}

                <Select
                  className="mt-1"
                  name="talukaDistrict"
                  options={talukaDistrictOptions}
                  value={selectedTalukaDistrict}
                  placeholder={commonLabels.COMBO_SELECT}
                  onChange={(selectedOption) => {
                    onDistrictChange({
                      target: {
                        name: "talukaDistrict",
                        value: selectedOption?.value || "",
                      },
                    });
                  }}
                  isClearable
                  isDisabled={addTaluka?.Mode === "Edit"}
                  ref={inputRef}
                />

                {_.get("talukaDistrict.type", errors) === "required" && (
                  <p className="errorText float-left">
                    {commonLabels.MANDATORY_FIELD_MESSAGE}
                  </p>
                )}
              </div>

              <div className="col-md-3">
                <label className="font-weight-bold float-left">
                  {masterLabels.talukaForm.Taluka_Name}
                  <span className="redColor">*</span>
                </label>
                <input
                  type="text"
                  className="form-control input-sm"
                  name="talukaName"
                  placeholder={masterLabels.talukaForm.Taluka_Name}
                  ref={register({ required: true, maxLength: 50 })}
                  defaultValue={
                    addTaluka &&
                    addTaluka.Mode == "Edit" &&
                    addTaluka.talukaName
                      ? addTaluka.talukaName
                      : ""
                  }
                  onChange={(event) => setTalukaName(event.target.value)}
                />
                {_.get("talukaName.type", errors) === "required" && (
                  <p className="errorText float-left">
                    {commonLabels.MANDATORY_FIELD_MESSAGE}
                  </p>
                )}
                {_.get("talukaName.type", errors) === "maxLength" && (
                  <p className="errorText float-left">
                    {commonLabels.MAX_CHAR_VALUE_50}
                  </p>
                )}
              </div>

              <div className="col-md-1">
                <label className="float-left font-weight-bold  text-left w-100">
                  {masterLabels.talukaForm.Taluka_Status}?&nbsp;&nbsp;
                </label>
                <input
                  className="float-left text-left"
                  type="checkbox"
                  name="isActive"
                  checked={isActive}
                  onChange={(e) => setIsActive(!isActive)}
                />
              </div>
            </div>
            <div className="row mt-5">
              <div className="col-md-10"></div>
              <div className="col-md-2 text-right">
                <button
                  type="button"
                  className="btn btn-secondary mr-2"
                  onClick={() => onCancelButton()}
                >
                  {commonLabels.BUTTON_CANCEL}
                </button>
                <button
                  type="submit"
                  className=" btn btn-primary custom_button   "
                  onClick={handleSubmit((e) => {
                    onSubmit(e, addTaluka, setAddTaluka, isActive);
                  })}
                >
                  {commonLabels.BUTTON_SAVE}
                </button>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
};

export default TehsilForm;
